export const ToolsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
    <path
      d="M22.7 19.3L17.4 14l1.4-1.4 2.1 2.1 1.4-1.4-2.1-2.1 1.4-1.4 2.1 2.1 1.4-1.4-2.1-2.1 1.4-1.4 2.1 2.1 1.4-1.4-5.3-5.3a5.5 5.5 0 0 0-7.8 0l-1.4 1.4a5.5 5.5 0 0 0 0 7.8l5.3 5.3 1.4-1.4-2.1-2.1 1.4-1.4 2.1 2.1 1.4-1.4-2.1-2.1 1.4-1.4 2.1 2.1 1.4-1.4-2.1-2.1 1.4-1.4 2.1 2.1 1.4-1.4zM8.6 13.4a3.5 3.5 0 1 1 0-5 3.5 3.5 0 0 1 0 5z"
      fill="#cfd1dc"
    />
  </svg>
);
